import React from 'react';

export const NEW_CHAT_TEXT = 'New chat';
export const UNTITLED_CHAT_TEXT = 'Untitled chat';

export interface ChatSession {
  /* In front-end code, a null id indicates a new chat. */
  id: string | null;
  /* Even a persisted chat may not have a name. */
  name: string | null;
}

export function getChatNameRenderInfo(item: ChatSession): {
  text: string;
  node: React.ReactNode;
} {
  if (item.name && item.name.trim()) {
    return {
      text: item.name,
      node: <span className="u-ellipsis-text">{item.name}</span>,
    };
  }
  if (item.id == null) {
    return {text: NEW_CHAT_TEXT, node: <em>{NEW_CHAT_TEXT}</em>};
  }
  return {text: UNTITLED_CHAT_TEXT, node: <em>{UNTITLED_CHAT_TEXT}</em>};
}
